/**
 * Origin страницы платформы, на которой смонтирован модуль; `null` — standalone.
 *
 * Нужен виджетам, которые ведут пользователя в ДРУГОЙ раздел платформы (например, отчёт
 * Patent Checker): в embed ссылка строится на origin хоста, в standalone платформы нет и
 * остаётся собственная ссылка сервиса. Выставляет `App.tsx` (слой `shared` об `app` не знает).
 */
import { createContext, useContext } from 'react';

export const PlatformOriginContext = createContext<string | null>(null);

export function usePlatformOrigin(): string | null {
  return useContext(PlatformOriginContext);
}
